import * as React from 'react';
import { Heading as Template, HeadingProps as BaseProps } from '@theme-ui/components';

type HeadingProps = BaseProps;

type HeadingLevel = 1 | 2 | 2 | 4 | 5 | 6;
const HeadingContext = React.createContext<HeadingLevel>(2);

interface HeadingProviderProps {
  level?: HeadingLevel;
  disabled?: boolean;
}

function useHeadingLevel() {
  return React.useContext(HeadingContext);
}

function HeadingProvider(props: React.PropsWithChildren<HeadingProviderProps>) {
  const currentLevel = useHeadingLevel();
  if (props.disabled) {
    return <>{props.children}</>;
  }
  return (
    // @ts-expect-error
    <HeadingContext.Provider value={props.level ?? currentLevel + 1}>
      {props.children}
    </HeadingContext.Provider>
  );
}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ as: asOverride, ...props }, ref) => {
    const currentLevel = useHeadingLevel();
    const as = asOverride ?? `h${currentLevel}`;
    return <Template {...props} ref={ref} as={as} />;
  }
);

export { Heading, HeadingProvider, useHeadingLevel };
export type { HeadingProps, HeadingLevel };
